document.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll<HTMLSelectElement>('select[data-language-switcher]')
		.forEach((select) => {
			select.addEventListener('change', () => {
				window.location.href = select.value;
			});
		});
});
